import { createEnumOptions } from '../shared/enum-option.interface';

export interface IRemotegateConstraint {
  groupId: string;

  type: RemotegateType;
}

export enum RemotegateType {
  ZA = 'ZA',
  BA = 'BA',
}

export const remotegateTypeOptions = createEnumOptions<RemotegateType>({
  [RemotegateType.BA]: { label: 'Remote BA' },
  [RemotegateType.ZA]: { label: 'Remote ZA' },
  _default: { label: '-' },
});
